<template>
  <div>
    <Nav />
    <Banner :title="title" v-if="selectedPost === false" />

    <div class="posts" v-if="selectedPost === false">
      <div class="container">
        <div class="row">
          <div
            :key="title + '-' + index"
            v-for="(item, index) in items"
            class="col-sm-12 col-md-4 col-lg-4 service"
          >
            <div class="card my-3">
              <figure class="post-image">
                <img
                  v-if="item.image"
                  :src="getImage(item.image)"
                  class="card-img-top"
                />
                <img v-else :src="placeholderImage()" class="card-img-top" />
              </figure>
              <div class="card-body">
                <h5 class="card-title text-center my-3">
                  {{ item.title | niceTitle }}
                </h5>

                <p class="card-text py-3">
                  {{ item.description }}
                </p>

                <p class="text-center">
                  <button
                    href="#"
                    class="btn btn-primary"
                    @click="selectedPost = item"
                  >
                    Submit Service Request
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="show-post p-3" v-else>
      <div
        v-if="selectedPost.image"
        class="post-hero text-center rounded"
        :style="'background-image: url(' + getImage(selectedPost.image) + ');'"
      >
        <h3>{{ selectedPost.title | niceTitle }} Service Request</h3>
      </div>
      <div
        v-else
        class="post-hero text-center rounded"
        :style="'background-image: url(' + placeholderImage() + ');'"
      >
        <h3>{{ selectedPost.title | niceTitle }} Service Request</h3>
      </div>
      <div class="post-content position-relative py-5">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="service-request-form py-3">
                <div class="form-group row">
                  <label for="name" class="col-sm-2 col-form-label">Name</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="serviceRequest.name"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="email" class="col-sm-2 col-form-label"
                    >Email</label
                  >
                  <div class="col-sm-10">
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      v-model="serviceRequest.email"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="phone" class="col-sm-2 col-form-label"
                    >Phone Number</label
                  >
                  <div class="col-sm-10">
                    <input
                      type="tel"
                      class="form-control"
                      id="phone"
                      v-model="serviceRequest.phone"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="address" class="col-sm-2 col-form-label"
                    >Address</label
                  >
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      v-model="serviceRequest.address"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="date" class="col-sm-2 col-form-label">Date</label>
                  <div class="col-sm-10">
                    <v-date-picker v-model="serviceRequest.date" is-expanded />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="time" class="col-sm-2 col-form-label">Time</label>
                  <div class="col-sm-10">
                    <input
                      type="time"
                      class="form-control"
                      id="time"
                      v-model="serviceRequest.time"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="additionalInfo" class="col-sm-2 col-form-label"
                    >Additional Info</label
                  >
                  <div class="col-sm-10">
                    <textarea
                      class="form-control"
                      id="additionalInfo"
                      v-model="serviceRequest.additionalInfo"
                    ></textarea>
                  </div>
                </div>
                <hr class="my-5" />
                <p class="text-right">
                  <button
                    class="btn btn-primary"
                    style="margin-right: 0.5rem;"
                    @click="selectedPost = false"
                  >
                    <i class="fas fa-chevron-left mr-1"></i> Back
                  </button>
                  <button class="btn btn-primary" @click="sendRequest">
                    Submit Request
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import axios from "axios";
import moment from "moment";


export default {
  name: "Services",
  components: {
    Banner: Banner
  },
  props: {
    title: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({
    items: [],
    placeholderImages: [
      require("@/assets/images/events_1.jpg"),
      require("@/assets/images/events_2.jpg"),
      require("@/assets/images/events_3.jpg"),
      require("@/assets/images/chaplin_2.jpg"),
      require("@/assets/images/chaplin_3.jpg"),
      require("@/assets/images/chaplin_4.jpg"),
      require("@/assets/images/news_1.jpg"),
      require("@/assets/images/news_2.jpg")
    ],
    selectedPost: false,
    serviceRequest: {
      name: "",
      email: "",
      phone: "",
      address: "",
      date: new Date(),
      time: "",
      additionalInfo: ""
    },
    required: [],
    niceNames: {
      name: "Name",
      email: "Email",
      phone: "Phone Number",
      address: "Address",
      date: "Date",
      time: "Time"
    }
  }),
  created() {
    this.getItems();
  },
  methods: {
    validate() {
      Object.keys(this.niceNames).forEach(n => {
        if (["", false, null].includes(this.serviceRequest[n])) {
          this.required.push(this.niceNames[n]);
        } else {
          if (this.required.includes(this.niceNames[n])) {
            const index = this.required.indexOf(this.niceNames[n]);
            if (index > -1) this.required.splice(index, 1);
          }
        }
      });
      return this.required.length === 0;
    },
    sendRequest() {
      console.log("submit", this.serviceRequest);
      const isValid = this.validate();
      console.log(isValid);
      if (isValid) {
        const data = { ...this.serviceRequest };
        data["isoDate"] = this.serviceRequest.date.toISOString();
        data["type"] = this.selectedPost.title;
        axios
          .post(process.env.VUE_APP_SERVER + "service-request", data)
          .then(res => {
            if (res.data.message.toLowerCase().indexOf("success") > -1) {
              this.$noty.success(res.data.message);
            }
          })
          .catch(error => {
            console.error(error);
            this.$noty.error("There was an issue submitting your request.");
          });
      } else {
        this.$noty.error(
          "Please fill out the required fields: " + this.required.join(", ")
        );
      }
    },
    getItems() {
      axios
        .get(process.env.VUE_APP_SERVER + this.title)
        .then(res => {
          if (res.data) {
            this.items = res.data.result;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    placeholderImage() {
      let eIndex = Math.floor(Math.random() * this.placeholderImages.length);
      if (eIndex > this.placeholderImages.length - 1) eIndex -= 1;
      const image = this.placeholderImages[eIndex];
      return image;
    },
    getImage(value) {
      return process.env.VUE_APP_IMAGES + value;
    }
  },
  filters: {
    niceDate(value) {
      return "Published " + moment.utc(value).format("MMM Do YYYY");
    },
    niceTitle(value) {
      if (value.indexOf(" ") > -1) {
        return value
          .split(" ")
          .map(w => {
            return w[0].toUpperCase() + w.substring(1);
          })
          .join(" ");
      } else {
        return value[0].toUpperCase() + value.substring(1);
      }
    }
  }
};
</script>

<style lang="scss">
.service {
  display: flex;
  width: 100%;
  @media all and (max-width: 500px) {
    display: block;
  }

  @media all and (max-width: 767px) {
    display: block;
  }
}

.search-item {
  border: solid 1px #ccc;
  border-radius: 20px;
  padding: 0.45rem;
  padding-left: 1rem;
  &:focus {
    outline: none;
  }
}

.search-icon {
  top: 12px;
  left: 168px;
  color: #ccc;
}

.posts {
  padding: 3rem 0;

  .post-image {
    margin: 0 0 1rem;
    max-height: 165px;
    overflow: hidden;

    margin-bottom: 1rem;

    img {
      position: relative;
      width: 110%;
      left: -5%;
      top: -5%;
    }
  }
}

.post-hero {
  background-size: 100%;
  background-position: 50%;
  min-height: 200px;
  h3 {
    padding-top: 4rem;
  }
  h4 {
    padding-bottom: 3rem;
  }
  h3,
  h4 {
    text-shadow: 0 0 5px #000;
    color: #fff;
  }
}

.post-content {
  min-height: 70vh;
  .col {
    min-height: 100%;
  }
}

.back-btn {
  text-align: right;
}
</style>
